function hemFaqToggle(btn) {
  var body = btn.nextElementSibling;
  var icon = btn.querySelector('.hem-faq__icon');
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  document.querySelectorAll('.hem-faq__trigger[aria-expanded="true"]').forEach(function(other) {
    if (other !== btn) {
      other.setAttribute('aria-expanded', 'false');
      other.nextElementSibling.style.maxHeight = null;
      other.querySelector('.hem-faq__icon').style.transform = '';
    }
  });
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    body.style.maxHeight = null;
    icon.style.transform = '';
  } else {
    btn.setAttribute('aria-expanded', 'true');
    body.style.maxHeight = body.scrollHeight + 'px';
    icon.style.transform = 'rotate(180deg)';
  }
}